export default "__VITE_ASSET__BL3Eqv33__"